import React from 'react';
import {FormattedMessage} from 'react-intl';
import {Input, Label} from 'semantic-ui-react';
import CurrencyFormat from 'react-currency-format';
import {any, bool, oneOf, arrayOf, oneOfType, string, element, func, object} from 'prop-types';
import {addThousandsCommas, EmptyFunc} from 'utils/DBUtils';

const supportedCurrencies = {
  USD: '$',
  GBP: '£'
};

export default class CurrencyInput extends React.Component {
  static propTypes = {
    currency: oneOf(Object.keys(supportedCurrencies)).isRequired,
    required: bool,
    label: oneOfType([string, element]),
    name: string.isRequired,
    value: any.isRequired,
    onValueChanged: func.isRequired,
    validationRules: arrayOf(object),
    errors: arrayOf(object)
  };

  static defaultProps = {
    errors: []
  };

  handleChange = (event, {value}) => {
    this.props.onValueChanged(value, true);
  };

  render() {
    return (
      <div className='field-with-inline-label'>
        {this.props.label}
        <Input
          type='number'
          name={this.props.name}
          onChange={this.handleChange}
          required={this.props.required}
          value={this.props.value || ''}
          error={this.props.errors.length > 0}
          label={supportedCurrencies[this.props.currency]} />
        {this.props.errors.map(error => {
          const messageValues = error.type === 'InclusiveRange' ? {
            min: error.params.min,
            max: addThousandsCommas(error.params.max)
          } : {};

          return (
            <Label
              basic
              className='db-error-label'
              key={error.type}>
              <FormattedMessage
                id={`errors.validation.${error.type}`}
                values={messageValues} />&nbsp;
              {error.invalidValues && (
                <FormattedMessage
                  id='errors.validation.invalid_values'
                  values={{invalidValues: error.invalidValues}} />
              )}
            </Label>
          );
        })}
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./public/components/forms/BasicFormFields/CurrencyInput.jsx